import {formatter, request} from '@/utils/request';

export namespace Accrual {
  const Path = {
    QueryServicesForAccrual: "/taskapi/accrual/queryServicesForAccrual",
    SearchAllowAccrual: "/taskapi/accrual/searchAllowAccrual",
    AccrualValidate: '/taskapi/accrual/accrualValidate',
    QueryServicesForAccrualMkt: '/taskapi/accrual/queryServicesForAccrualMkt',
    SearchAllowAccrualMkt: "/taskapi/accrual/searchAllowAccrualMkt",
    AccrualValidateMkt: '/taskapi/accrual/accrualValidateMkt',
    NextAccrualYM: "/taskapi/accrual/nextAccrualYm",
    CurrentAccrualYMByBohqId: "/taskapi/accrual/currentAccrualYmByBohqId",
    CurrentAccrualYM: "/taskapi/accrual/currentAccrualYm",
    CurrentYM: "/taskapi/accrual/currentYm",
    AccrualSimulate: '/taskapi/accrual/accrualSimulate',
    QueryServicesForForecastAccrual: '/taskapi/accrual/queryServicesForForecastAccrual',
    GetMaxAccrualRecords: '/taskapi/accrual/getMaxAccrualRecords',
    GetMktMaxAccrualRecords: '/taskapi/accrual/getMktMaxAccrualRecords',
  }

  export async function queryServicesForAccrual(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.ServiceQuery>>(Path.QueryServicesForAccrual, formatter(options));
  }

  export async function searchAllowAccrual(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.AccrualValidateResult>>(Path.SearchAllowAccrual, formatter(options));
  }

  export async function accrualValidate(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any>>(Path.AccrualValidate, formatter(options));
  }

  export async function queryServicesForAccrualMkt(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.ServiceQuery>>(Path.QueryServicesForAccrualMkt, formatter(options));
  }

  export async function searchAllowAccrualMkt(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.AccrualValidateResult>>(Path.SearchAllowAccrualMkt, formatter(options));
  }

  export async function accrualValidateMkt(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any>>(Path.AccrualValidateMkt, formatter(options));
  }

  export async function nextAccrualYm(bohqCategoryId: number) {
    const options = {
      method: 'GET',
      body: {
        bohqCategoryId: bohqCategoryId
      }
    };
    return request<API.ResponseResult<any>>(Path.NextAccrualYM, formatter(options));
  }

  export async function currentAccrualYmByBohqId(bohqId: number) {
    const options = {
      method: 'GET',
      body: {
        bohqId: bohqId
      }
    };
    return request<API.ResponseResult<any>>(Path.CurrentAccrualYMByBohqId, formatter(options));
  }

  export async function currentAccrualYm(bohqCategoryId: number) {
    const options = {
      method: 'GET',
      body: {
        bohqCategoryId: bohqCategoryId
      }
    };
    return request<API.ResponseResult<any>>(Path.CurrentAccrualYM, formatter(options));
  }

  export async function currentYm() {
    const options = {
      method: 'GET',
      body: {}
    };
    return request<API.ResponseResult<any>>(Path.CurrentYM, formatter(options));
  }

  export async function accrualSimulate(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<boolean>>(Path.AccrualSimulate, formatter(options));
  }


  export async function queryServicesForForecastAccrual(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.QueryResult<API.ServiceQuery>>(Path.QueryServicesForForecastAccrual, formatter(options));
  }

  export async function getMaxAccrualRecords(rebateType?: number) {
    const options = {
      method: 'GET',
      body: {
        rebateType: rebateType
      },
    };
    return request<API.ResponseResult<API.AccrualRecordMaxVo[]>>(Path.GetMaxAccrualRecords, formatter(options));
  }

  export async function getMktMaxAccrualRecords() {
    const options = {
      method: 'GET',
      body: {},
    };
    return request<API.ResponseResult<API.AccrualRecordMaxVo[]>>(Path.GetMktMaxAccrualRecords, formatter(options));
  }
}
